import React from "react";

import { Route, Routes } from "react-router-dom";
import "./App.css";

import NotFound from "./NotFound/NotFound";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import CustomerRoutes from "./AcuvisorCustomerApp/Routes/CustomerRoutes.js";
import SignIn from "./AcuvisorCustomerApp/components/userAuth/SignIn.jsx";
import HumanLifeValue from "./AcuvisorCustomerApp/components/humanlifevalue/HumanLifeValue.jsx";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import LearnAboutPOSP from "./AcuvisorCustomerApp/components/StartAsPOSP/LearnAboutPOSP.jsx";

// Create a react query client
const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <div className="App-body">
        <ToastContainer />

        <Routes>
          <Route path="/*" element={<CustomerRoutes />} />

          {/*Todo: this will be removed or handled more optimized*/}
          <Route path="/signin" element={<SignIn defaultOpen={true} />} />
          <Route
            path="/customer/human-life-value"
            element={<HumanLifeValue />}
          />
          <Route
            path="/customer/learn-about-posp"
            element={<LearnAboutPOSP />}
          />

          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>

      <ReactQueryDevtools
        initialIsOpen={false}
        buttonPosition="bottom-left"
        position="bottom"
      />
    </QueryClientProvider>
  );
}

export default App;
